export const MarketplaceStatus = {
  DoNotShow: 0,
  OAuthFlow: 1,
  Temu: 2,
  Skupreme: 3,
  Walmart: 5,
  Shopify: 6,
  Facebook: 8,
  BigCommerce: 9,
  WooCommerce: 10,
  Sears: 11,
  Bonanza: 13,
  Wayfair: 14,
  NetSuite: 15,
};

export const availableAdsIntegration = ['amazon'];
export const ConfigurableMarketplace = ['amazon', 'walmart', 'shopify'];
export const DYNAMIC_INFORMATION = ['etsy', 'walmart', 'shopify', 'ebay'];
export const DISABLED_DYNAMIC_INFORMATION = ['amazon'];
